import { render, staticRenderFns } from "./InputTextMultiLine.vue?vue&type=template&id=f28a8ce6&scoped=true&"
import script from "./InputTextMultiLine.vue?vue&type=script&lang=js&"
export * from "./InputTextMultiLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28a8ce6",
  null
  
)

export default component.exports